import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import RussellvilleHeroSection from "./components/HeroSection";
import RussellvilleStickyNav from "./components/StickyNav";
import RussellvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import RussellvilleServicesSection from "./components/ServicesSection";
import RussellvilleLocalAreaSection from "./components/LocalAreaSection";
import RussellvilleTravelTimingSection from "./components/TravelTimingSection";
import RussellvilleDestinationsSection from "./components/DestinationsSection";
import RussellvilleTestimonialsSection from "./components/TestimonialsSection";
import RussellvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import RussellvilleComparisonSection from "./components/ComparisonSection";
import RussellvilleMistakesSection from "./components/MistakesSection";
import RussellvilleHowItWorksSection from "./components/HowItWorksSection";
import RussellvilleFAQSection, { faqs } from "./components/FAQSection";
import RussellvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import RussellvilleFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function RussellvillePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Russellville"
        state="Arkansas"
        stateAbbr="AR"
        route="/russellville"
        title="Emergency Passport Russellville, AR — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Russellville, AR — as fast as 24 hours. Serving ATU students, Arkansas Nuclear One professionals, and River Valley mission teams. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Russellville, Arkansas"
        geoPosition="35.2784;-93.1338"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
      />
      <RussellvilleHeroSection />
      <RussellvilleStickyNav />
      <RussellvilleProcessingTimeSection />
      <RussellvilleLocalAreaSection />
      <RussellvilleServicesSection />
      <RussellvilleTravelTimingSection />
      <RussellvilleDestinationsSection />
      <RussellvilleTestimonialsSection />
      <RussellvilleAcceptanceFacilitiesSection />
      <RussellvilleComparisonSection />
      <RussellvilleMistakesSection />
      <RussellvilleHowItWorksSection />
      <RussellvilleFAQSection />
      <RussellvilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/russellville" state="AR" />
      <RussellvilleFinalCTA />
    </div>
  );
}